module.exports = __webpack_public_path__ + "static/media/watson.f537c88e.png";